import React from "react";
import { Link } from "react-router-dom";
import decoratedpatternlightsvg from "../assets/images/decorated-pattern-light.svg";
import decoratedpatterndarksvg from "../assets/images/decorated-pattern-dark.svg";
import bgheader3png from "../assets/images/bg-header-3.png";
import product1png from "../assets/images/product-1.png";

function Index(props) {
  const imageUrl = decoratedpatternlightsvg;
  const imageUrl1 = decoratedpatterndarksvg;
  return (
    <>
      <header className="dx-header dx-box-4">
        <div className="bg-image bg-image-parallax">
          <img src={bgheader3png} className="jarallax-img" alt="" />
          <div style={{ backgroundColor: "rgba(27, 27, 27, .8)" }}></div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-8 col-lg-6 col-xl-5">
              <h1 className="display-3 text-white">Amdesk Template</h1>
              <p className="lead text-1">
                A high quality Bootstrap 4 template for your digital products
                with help center
              </p>
              <Link to="/store" className="dx-btn dx-btn-lg mt-10">
                View Products
              </Link>
            </div>
          </div>
        </div>
      </header>
      <div className="dx-box-1">
        <div className="container">
          <div className="row vertical-gap lg-gap">
            <div className="col-lg-4">
              <div className="dx-feature dx-feature-1">
                <div className="dx-feature-decorated"></div>
                <div className="dx-feature-icon">
                  <span className="icon pe-7s-diamond"></span>
                </div>
                <div className="dx-feature-cont">
                  <div className="dx-feature-title">7700 +</div>
                  <div className="dx-feature-text">Happy Customers</div>
                </div>
              </div>
              <div className="dx-feature dx-feature-1">
                <div className="dx-feature-decorated"></div>
                <div className="dx-feature-icon">
                  <span className="icon pe-7s-like"></span>
                </div>
                <div className="dx-feature-cont">
                  <div className="dx-feature-title">4.9</div>
                  <div className="dx-feature-text">Author Rating</div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <h2>Who we are</h2>
              <p className="mb-0">
                We a team of enthusiasts that creating powerful digital
                products, that help your businesses growth. For all products, we
                provide a year of support and lifetime security updates.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="dx-box-1 bg-dark-1">
        <div className="container">
          <div className="row mnt-40 mnb-40">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="dx-feature dx-feature-2">
                <div className="dx-feature-cont">
                  <div className="dx-feature-icon">
                    <span className="icon pe-7s-edit"></span>
                  </div>
                  <div className="dx-feature-title">Easy Setup</div>
                  <div className="dx-feature-text">
                    We make our products easy to setup and customize.
                  </div>
                </div>
                <span
                  className="dx-decorated"
                  style={{
                    backgroundImage: `url(${imageUrl1})`,
                  }}
                ></span>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="dx-feature dx-feature-2">
                <div className="dx-feature-cont">
                  <div className="dx-feature-icon">
                    <span className="icon pe-7s-paint-bucket"></span>
                  </div>
                  <div className="dx-feature-title">Perfect Design</div>
                  <div className="dx-feature-text">
                    Choose our solutions and your website will be in a trend
                    always.
                  </div>
                </div>
                <span
                  className="dx-decorated"
                  style={{
                    backgroundImage: `url(${imageUrl1})`,
                  }}
                ></span>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="dx-feature dx-feature-2">
                <div className="dx-feature-cont">
                  <div className="dx-feature-icon">
                    <span className="icon pe-7s-timer"></span>
                  </div>
                  <div className="dx-feature-title">Lifetime Updates</div>
                  <div className="dx-feature-text">
                    We improve our products after release and you will get it
                    for free.
                  </div>
                </div>
                <span
                  className="dx-decorated"
                  style={{
                    backgroundImage: `url(${imageUrl1})`,
                  }}
                ></span>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="dx-feature dx-feature-2">
                <div className="dx-feature-cont">
                  <div className="dx-feature-icon">
                    <span className="icon pe-7s-cloud-download"></span>
                  </div>
                  <div className="dx-feature-title">Freebies</div>
                  <div className="dx-feature-text">
                    Not only paid products, but also freebies available.
                  </div>
                </div>
                <span
                  className="dx-decorated"
                  style={{
                    backgroundImage: `url(${imageUrl1})`,
                  }}
                ></span>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="dx-feature dx-feature-2">
                <div className="dx-feature-cont">
                  <div className="dx-feature-icon">
                    <span className="icon pe-7s-portfolio"></span>
                  </div>
                  <div className="dx-feature-title">Clean Code</div>
                  <div className="dx-feature-text">
                    All our products provided with best code quality and high
                    performance.
                  </div>
                </div>
                <span
                  className="dx-decorated"
                  style={{
                    backgroundImage: `url(${imageUrl1})`,
                  }}
                ></span>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="dx-feature dx-feature-2">
                <div className="dx-feature-cont">
                  <div className="dx-feature-icon">
                    <span className="icon pe-7s-headphones"></span>
                  </div>
                  <div className="dx-feature-title">Outstanding Support</div>
                  <div className="dx-feature-text">
                    We provide fast and professional support through support
                    system.
                  </div>
                </div>
                <span
                  className="dx-decorated"
                  style={{
                    backgroundImage: `url(${imageUrl1})`,
                  }}
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dx-box-1 bg-grey-6">
        <div className="container">
          <h2 className="text-center mb-60">Latest Products</h2>
          <div className="row vertical-gap">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="dx-portfolio-item dx-block-decorated">
                <div className="dx-portfolio-item-image">
                  <div
                    className="dx-portfolio-item-overlay"
                    style={{ backgroundColor: "rgba(27, 27, 27, .8)" }}
                  >
                    <Link
                      to="/#"
                      className="dx-btn dx-btn-md dx-btn-transparent-style-2 m-10"
                    >
                      Live Demo
                    </Link>
                    <Link
                      to="/#"
                      className="dx-btn dx-btn-md dx-btn-transparent-style-2 m-10"
                    >
                      Buy Now
                    </Link>
                  </div>
                  <img src={product1png} alt="" />
                </div>
                <Link to="/product" className="dx-portfolio-item-info">
                  <span className="dx-portfolio-item-title">
                    Quantial – Moving Upon Signs Moveth Lesser
                  </span>
                  <span className="dx-portfolio-item-price">$49</span>
                </Link>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="dx-portfolio-item dx-block-decorated">
                <div className="dx-portfolio-item-image">
                  <div
                    className="dx-portfolio-item-overlay"
                    style={{ backgroundColor: "rgba(27, 27, 27, .8)" }}
                  >
                    <Link
                      to="/#"
                      className="dx-btn dx-btn-md dx-btn-transparent-style-2 m-10"
                    >
                      Live Demo
                    </Link>
                    <Link
                      to="/#"
                      className="dx-btn dx-btn-md dx-btn-transparent-style-2 m-10"
                    >
                      Buy Now
                    </Link>
                  </div>
                  <img src={product1png} alt="" />
                </div>
                <Link to="/product" className="dx-portfolio-item-info">
                  <span className="dx-portfolio-item-title">
                    Sensific – Saying Beast Lesser for in Fruitful
                  </span>
                  <span className="dx-portfolio-item-price">$59</span>
                </Link>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="dx-portfolio-item dx-block-decorated">
                <div className="dx-portfolio-item-image">
                  <div
                    className="dx-portfolio-item-overlay"
                    style={{ backgroundColor: "rgba(27, 27, 27, .8)" }}
                  >
                    <Link
                      to="/#"
                      className="dx-btn dx-btn-md dx-btn-transparent-style-2 m-10"
                    >
                      Live Demo
                    </Link>
                    <Link
                      to="/#"
                      className="dx-btn dx-btn-md dx-btn-transparent-style-2 m-10"
                    >
                      Buy Now
                    </Link>
                  </div>
                  <img src={product1png} alt="" />
                </div>
                <Link to="/product" className="dx-portfolio-item-info">
                  <span className="dx-portfolio-item-title">
                    Minist – Subdue Above for Signs Dry is Have Great
                  </span>
                  <span className="dx-portfolio-item-price">$39</span>
                </Link>
              </div>
            </div>
          </div>
          <div className="text-center mt-70">
            <Link to="/#" className="dx-btn dx-btn-lg">
              View Products
            </Link>
          </div>
          <div className="dx-box-1">
            <span
              className="dx-decorated"
              style={{
                backgroundImage: `url(${imageUrl})`,
              }}
            ></span>
          </div>
          <h2 className="text-center mb-40">Reviews</h2>
          <div className="dx-box">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <div
                  className="swiper-container dx-slider dx-slider-arrows dx-slider-reviews"
                  data-swiper-speed="400"
                  data-swiper-space="0"
                  data-swiper-slides="2"
                  data-swiper-arrows="true"
                  data-swiper-arrows-clone="true"
                  data-swiper-pagination-dynamic="true"
                  data-swiper-breakpoints="true"
                  data-swiper-loop="true"
                  data-swiper-grabCursor="true"
                >
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      <div className="dx-swiper-slide">
                        <div className="dx-review dx-block-decorated">
                          <div>
                            <div className="dx-review-title">
                              Matthew Stewart
                            </div>
                            <div className="dx-review-subtitle">
                              Themeforest User
                            </div>
                            <div className="dx-review-text lead">
                              Theme is brilliantly designed. I will see how much
                              is customizable and leave another review when
                              planned is done on the theme. Good job guys.
                            </div>
                          </div>
                          <div className="dx-review-rating">
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="dx-swiper-slide">
                        <div className="dx-review dx-block-decorated">
                          <div>
                            <div className="dx-review-title">Paula Daniel</div>
                            <div className="dx-review-subtitle">
                              Themeforest User
                            </div>
                            <div className="dx-review-text lead">
                              Quality template. Built-in design features made it
                              applicable not only to game portals but also to a
                              business/industrial sites.
                            </div>
                          </div>
                          <div className="dx-review-rating">
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="dx-swiper-slide">
                        <div className="dx-review dx-block-decorated">
                          <div>
                            <div className="dx-review-title">Robert Chase</div>
                            <div className="dx-review-subtitle">
                              Themeforest User
                            </div>
                            <div className="dx-review-text lead">
                              It took a little while but I was finally able to
                              get the demo data up and was able to get a handle
                              on this theme. I am impressed with the
                              features/functionality and with the responsiveness
                              of the support group.
                            </div>
                          </div>
                          <div className="dx-review-rating">
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="dx-swiper-slide">
                        <div className="dx-review dx-block-decorated">
                          <div>
                            <div className="dx-review-title">Oliver Harris</div>
                            <div className="dx-review-subtitle">
                              Themeforest User
                            </div>
                            <div className="dx-review-text lead">
                              Thanks, so much I love it... So far, I&#39;ve
                              never seen a theme like it...I want to thank you
                              for your quick response as well... thanks
                            </div>
                          </div>
                          <div className="dx-review-rating">
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="dx-swiper-slide">
                        <div className="dx-review dx-block-decorated">
                          <div>
                            <div className="dx-review-title">
                              Matthew Stewart
                            </div>
                            <div className="dx-review-subtitle">
                              Themeforest User
                            </div>
                            <div className="dx-review-text lead">
                              Theme is brilliantly designed. I will see how much
                              is customizable and leave another review when
                              planned is done on the theme. Good job guys.
                            </div>
                          </div>
                          <div className="dx-review-rating">
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="dx-swiper-slide">
                        <div className="dx-review dx-block-decorated">
                          <div>
                            <div className="dx-review-title">Paula Daniel</div>
                            <div className="dx-review-subtitle">
                              Themeforest User
                            </div>
                            <div className="dx-review-text lead">
                              Quality template. Built-in design features made it
                              applicable not only to game portals but also to a
                              business/industrial sites.
                            </div>
                          </div>
                          <div className="dx-review-rating">
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                            <span className="fas fa-star"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-pagination"></div>
                  <div className="swiper-button-prev">
                    <span className="icon pe-7s-angle-left"></span>
                  </div>
                  <div className="swiper-button-next">
                    <span className="icon pe-7s-angle-right"></span>
                  </div>
                </div>
              </div>
            </div>
            <div className="dx-slider-arrows-clone dx-slider-arrows-reviews"></div>
          </div>
        </div>
      </div>
      <div className="row no-gutters">
        <div className="col-lg-6 bg-dark-1">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="container">
                <div className="dx-box-1">
                  <h2 className="text-white">Latest Products</h2>
                  <p className="text-2">
                    Join the newsletter to receive news, updates, new products
                    and freebies in your inbox.
                  </p>
                  <Link
                    data-fancybox
                    to="/"
                    className="dx-btn dx-btn-lg dx-btn-transparent"
                  >
                    Subscribe
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 bg-main-1">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="container">
                <div className="dx-box-1">
                  <h2 className="text-white">Visit our Support Desk</h2>
                  <p className="text-white op-8">
                    We have a Support Desk for our users and a well experienced
                    team to quickly answer your questions.
                  </p>
                  <Link
                    to="/help-center"
                    className="dx-btn dx-btn-lg dx-btn-transparent"
                  >
                    Get support
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Index;
